export default __webpack_public_path__ + "static/media/musd3CRV.fe7cf732.svg";